import { EffectCallback, useEffect } from 'react';

export const useMount = (cb: EffectCallback) => {
    useEffect(cb, []);
};
